export const processBulkLoadResponse = ({ products = [], inventory = [] }) => {
  const inventoryMap = new Map();

  inventory?.forEach((inv) => {
    const existing = inventoryMap.get(inv.productId);
    if (existing) {
      // Aggregate numeric properties
      inventoryMap.set(inv.productId, {
        ...existing,
        stock: (existing.stock || 0) + (inv.stock || 0),
        available: (existing.available || 0) + (inv.available || 0),
        allocated: (existing.allocated || 0) + (inv.allocated || 0),
      });
    } else {
      inventoryMap.set(inv.productId, inv);
    }
  });

  return products?.map((product) => ({
    ...product,
    id: product.productId,
    inventory: inventoryMap.get(product.productId),
  }));
};
